module.exports = __webpack_public_path__ + "img/1.bf0dbf04.png";